import { baseRoutes } from "helpers/baseRoutes";

/**
 * Define access routes related to book management, including paths and icons using baseRoutes from the "helpers/baseRoutes" module.
 * @constant {Object} accessRoute
 */
const accessRoute = {
  BOOK_MANAGEMENT: {
    path: `${baseRoutes.adminBaseRoutes}/book-management`,
    icon: (
      <span className="nk-menu-icon">
        <em className="icon ni ni-book" />
      </span>
    ),
  },
  BOOK_DETAILS: {
    path: `${baseRoutes.adminBaseRoutes}/book-details`,
    icon: (
      <span className="nk-menu-icon">
        <em className="icon ni ni-book" />
      </span>
    ),
  },
};

export default accessRoute;
